import { contactSearch } from './contact-search';
import { encoders } from './encoders';
import { hardwareModels } from './hardware-models';
import { hardwareUnits } from './hardware-units';
import { users } from './users';

export const v1 = {
  contactSearch,
  hardwareUnits,
  encoders,
  hardwareModels,
  users,
};
